import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { NotificationI18nService } from "../core/util/notification-i18n.service";
import { UserService } from "./user.service";

const TOKEN_KEY = "auth-token";
const USER_KEY = "auth-user";
const USER_ID = "auth_user_id";

@Injectable({
  providedIn: "root",
})
export class TokenStorageService {
  private _userService: any;

  constructor(
    private _injector: Injector,
    private _router: Router,
    private _notificationI18n: NotificationI18nService
  ) { }

  private get userService() {
    if (!this._userService) {
      this._userService = this._injector.get(UserService);
    }
    return this._userService;
  }

  timeoutID: any;

  dataUserForm = {
    nombre: "",
    apellido1: "",
    apellido2: "",
    id: "",
    email: "",
    tfa: "",
    "2faEnabled": "",
    rol: "",
    representados: [],
    esRepresentado: [],
    numero_documento: "",
    tipo_documento: "",
    tipopersona: "",
    telefono: "",
    direcciones: [],
    titulacion: "",
    fechaNacimiento: "",
    genero: "",
    email_confirmado: "",
    usuarioRepresenta: ""
  };
  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);

    //this.setExpitationTimeout();
  }

  public getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  public getId(): string | null {
    return window.sessionStorage.getItem(USER_ID).replace(/["]/g, "");
  }

  public setUser(user, userRepresenta?): void {

    window.sessionStorage.setItem(USER_ID, user.id);
    window.sessionStorage.setItem(
      USER_KEY,
      JSON.stringify(this.buildDataUser(user, {}, userRepresenta))
    );
  }

  public saveUser(): void {
    window.sessionStorage.removeItem(USER_KEY);
    firstValueFrom(this.userService.getCurrentUserRepresented()).then(
      (dataRepresented: any) => {
        firstValueFrom(this.userService.getCurrentUserFromServer()).then(
          (dataUser: any) => {

            this.buildDataUser(dataUser.Usuario, dataRepresented, dataUser.usuarioRepresenta);
            window.sessionStorage.setItem(USER_ID, dataUser.Usuario.id);
            window.sessionStorage.setItem(
              USER_KEY,
              JSON.stringify(this.dataUserForm)
            );
          }
        );
      }
    );
  }

  buildDataUser(dataUser, dataRepresented, usuarioRepresenta?) {


    this.dataUserForm.id = dataUser.id;
    this.dataUserForm.nombre = dataUser.nombre;
    this.dataUserForm.apellido1 = dataUser.apellido1;
    this.dataUserForm.apellido2 = dataUser.apellido2;
    this.dataUserForm.tfa =
      dataUser.twoFactorSecret != null ? dataUser.twoFactorSecret : "disabled";
    this.dataUserForm.email = dataUser.email;
    this.dataUserForm.titulacion = dataUser.titulacion;
    this.dataUserForm.fechaNacimiento = dataUser.fechaNacimiento;
    this.dataUserForm.genero = dataUser.genero;
    this.dataUserForm.email_confirmado = dataUser.email_confirmado;

    this.dataUserForm["2faEnabled"] = dataUser.twoFactorEnabled;
    this.dataUserForm.rol = dataUser.rol.map((item) => item.id);
    this.dataUserForm.representados = dataUser.representados;
    this.dataUserForm.numero_documento = dataUser.numero_documento;
    this.dataUserForm.tipo_documento = dataUser.tipo_documento;
    this.dataUserForm.tipopersona = dataUser.tipopersona;
    this.dataUserForm.telefono = dataUser.telefono;
    this.dataUserForm.direcciones = dataUser.direcciones;
    this.dataUserForm.representados = dataRepresented.representa
      ? ""
      : dataRepresented.representa;
    this.dataUserForm.esRepresentado = dataRepresented.representado_por
      ? ""
      : dataRepresented.representado_por;
    this.dataUserForm.usuarioRepresenta = usuarioRepresenta;
    return this.dataUserForm;
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  setExpitationTimeout() {
    clearTimeout(this.timeoutID);
    this.timeoutID = setTimeout(() => {
      this.signOutExpirationAndRedirectTo("/");
    }, 45 * 60000);
  }

  signOutExpirationAndRedirectTo(path, queryParams?): void {
    window.sessionStorage.clear();
    this._router
      .navigate([path], { queryParams: queryParams, replaceUrl: true })
      .then(() => {
        window.location.reload();
        this._notificationI18n.warning('SESSION.EXPIRED.MESSAGE', 50000);
      });
  }
}
